import { http } from 'helpers/httpv2';

const URL_V2 = process.env.REACT_APP_API_V2;
const URL = process.env.REACT_APP_API;
const loginAdminV2 = 'auth/admin-company';
const loginEmployeeV2 = 'auth/employee';
const login = 'authentication/login';

export const apiLoginAdminV2 = async (val) => {
  const datas = await http.post(`${URL_V2 + loginAdminV2}`, val);
  return datas.data;
};
export const apiLoginEmployeeV2 = async (val) => {
  const datas = await http.post(`${URL_V2 + loginEmployeeV2}`, val);
  return datas.data;
};
